module.exports = __webpack_public_path__ + "img/softIndicatorScore.291304d8.png";